import React, { useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import "./styles/PageBands.css";

import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutUs from "./components/AboutUs";
import SeoLocalSection from "./components/SeoLocalSection";
import Services from "./components/Services";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import AQuienesBuscamos from "./components/AQuienesBuscamos";
import GraduacionesNican from "./components/GraduacionesNican";
import Certificaciones from "./components/Certificaciones";
import Mapa from "./components/Mapa";
import PreguntasFrecuentes from "./components/PreguntasFrecuentes";
import InvitacionDescuento from "./components/InvitacionDescuento";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import InscripcionPasos from "./components/InscripcionPasos";
import AvisoDePrivacidad from "./components/AvisoDePrivacidad";
import Conocer from "./components/Conocer";
import CertificadosCarousel from "./components/CertificadosCarousel";
import CalificacionesRocola from "./components/Calificaciones";
import VideoRecomendacion from "./components/VideoRecomendacion";
import FaqPage from "./FaqPage";
import CoursePage from "./components/CoursePage";
import BlogPage from "./components/BlogPage";
import BlogPostPage from "./components/BlogPostPage";
import HomeBlogSection from "./components/HomeBlogSection";
import { trackPageView } from "./utils/analytics";

function HomePage() {
  return (
    <>
      <Helmet>
        <html lang="es-MX" />
        <title>
          Cursos de Enfermeria y Certificaciones SEP en Ixtapaluca | Fundacion
          Nican
        </title>
        <meta
          name="description"
          content="Aprende Enfermeria, Quiropractica, Fisioterapia y Certificaciones SEP en Fundacion Nican."
        />
        <link rel="canonical" href="https://fundacionnican.com/" />
      </Helmet>
      <HeroSection />
      <div className="page-band page-band-soft">
        <AQuienesBuscamos />
      </div>
      <div className="page-band page-band-white">
        <AboutUs />
      </div>
      <div className="page-band page-band-muted">
        <GraduacionesNican />
      </div>
      <div className="page-band page-band-white">
        <SeoLocalSection />
      </div>
      <div className="page-band page-band-white">
        <Services />
      </div>
      <InvitacionDescuento />
      <div className="page-band page-band-muted">
        <CertificadosCarousel />
      </div>
      <div className="page-band page-band-white">
        <Certificaciones />
      </div>
      <div className="page-band page-band-white">
        <Mapa />
      </div>
      <InscripcionPasos />
      <div className="page-band page-band-muted">
        <CalificacionesRocola />
      </div>
      <div className="page-band page-band-white">
        <VideoRecomendacion />
      </div>
      <div className="page-band page-band-muted">
        <ContactForm />
      </div>
      <section id="faq" className="page-band page-band-white">
        <PreguntasFrecuentes />
      </section>
      <div className="page-band page-band-muted">
        <HomeBlogSection />
      </div>
    </>
  );
}

function NotFound() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Pagina no encontrada</h1>
      <p>La ruta que buscaste no existe.</p>
      <a href="/">Volver al inicio</a>
    </div>
  );
}

function AnalyticsRouteTracker() {
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    trackPageView(`${location.pathname}${location.search}`);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Router>
      <AnalyticsRouteTracker />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/AvisoDePrivacidad" element={<AvisoDePrivacidad />} />
        <Route path="/Conocer" element={<Conocer />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:blogSlug" element={<BlogPostPage />} />
        <Route path="/:courseSlug" element={<CoursePage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <FloatingWhatsApp />
    </Router>
  );
}

export default App;
